import React from 'react';
import workspaceQuery from 'graphql/queries/nominal/NominalReportCategoryWorkspaceQuery.graphql';
import listQuery from 'graphql/queries/nominal/NominalReportCategoryListQuery.graphql';
import instanceQuery from 'graphql/queries/nominal/NominalReportCategoryQuery.graphql';
import defaultQuery from 'graphql/queries/nominal/NominalReportCategoryDefault.graphql';
import mutationQuery from 'graphql/mutations/nominal/NominalReportCategoryMutation.graphql';
import fragment from 'graphql/fragments/nominal/NominalReportCategoryFragment.graphql';
import { IDropdownOptionRenderer } from '../../../@types/entityTypes';
import { INominalReportCategory } from '../../schema/p4types';

const NominalReportCategoryOptionRenderer: IDropdownOptionRenderer = ({
  option,
}: {
  option: INominalReportCategory | Array<INominalReportCategory> | undefined;
}) => {
  if (Array.isArray(option)) {
    const content = option.map((value) => value.description).join(', ');
    return <span>{content}</span>;
  }
  return <span>{option?.description}</span>;
};

const NominalReportCategory = {
  type: 'NominalReportCategory',
  title: 'Nominal Report Categories',
  formTitle: 'Nominal Report Category',
  formUrl: '/Nominal/ReportCategory/Details/',
  workspaceUrl: '/Nominal/ReportCategory/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'description',
    optionRenderer: NominalReportCategoryOptionRenderer,
    valueRenderer: NominalReportCategoryOptionRenderer,
  },
  fragment,
  screenReference: 'NOMINAL_REPORT_CATEGORIES',
};

export default NominalReportCategory;
